/**
 * common路由
 */
import { RouteConfig } from 'vue-router'

import { WhiteBarStyle } from '$utils/bar-style'

const routers: RouteConfig[] = []
routers.push(
  {
    path: '/',
    meta: {
      title: '神象云年卡套餐',
      barStyle: WhiteBarStyle
    },
    // component: () => import(/* webpackChunkName: "_bury_" */ '$views/index/index.vue')
    component: () => import(/* webpackChunkName: "_bury_" */ '$views/offline/offline.vue')
  },
  {
    path: '/result',
    meta: {
      title: '结果',
      barStyle: WhiteBarStyle
    },
    component: () => import(/* webpackChunkName: "_bury_" */ '$views/result/index.vue')
  },
)

export default routers
